import { get, post, put, del, postKeepalive } from "@common/services/request";
import { apiEndpoints as api } from "@common/constants/urls";
import COMMAND_TYPES from "@common/constants/commandTypes";
import { SESSION_TYPES } from "@common/constants/sessionConstants";

export const startAcidCleaningSession = (deviceUUID) =>
  post(api.sessions, {
    minibrew_uuid: deviceUUID,
    session_type: SESSION_TYPES.SESSION_ACID_CLEAN_MINIBREW,
  });

export const startCleaningSession = (deviceUUID) =>
  post(api.sessions, {
    minibrew_uuid: deviceUUID,
    session_type: SESSION_TYPES.SESSION_TYPE_CLEAN_MINIBREW,
  });

export const getSessionsByRecipeId = (recipeId) =>
  get(`${api.sessions}?beer_recipe=${recipeId}`);

export const getSessionById = (Id) => get(`${api.sessions}${Id}/`);

export const listActiveSessions = () => get(`${api.sessions}?status_in=0,1`);

export const startSession = (body) => post(api.sessions, body);

export const updateSession = (sessionId, body) =>
  put(`${api.sessions}${sessionId}/`, body);

// abortTeardown is the operator override for a device parked at CIP-done: a plain
// force-delete refuses to fake it idle (409 carrying can_override, or a 200
// "resuming-teardown" that only resumes it), so this is the way out when the
// resume never lands. Only meaningful together with force.
export const deleteSession = (
  sessionId,
  force = false,
  abortTeardown = false,
) =>
  del(
    `${api.sessions}${sessionId}/${force ? "?force=true" : ""}${
      force && abortTeardown ? "&abort_teardown=true" : ""
    }`,
  );

export const resumeSession = (sessionId, userAction) =>
  put(`${api.sessions}${sessionId}/`, {
    command_type: COMMAND_TYPES.CMD_RESUME_PROCESS,
    resume_action: userAction,
  });

export const stopServing = (sessionId) =>
  put(`${api.sessions}${sessionId}/`, {
    command_type: COMMAND_TYPES.CMD_STOP_PROCESS,
  });

// Stopping a fermentation session (LEGEND keg) uses the same command as stopServing
export const stopFermentation = stopServing;

export const startFermentationSession = (kegUuid, opts) =>
  post(api.sessions, {
    keg_uuid: kegUuid,
    session_type: SESSION_TYPES.SESSION_TYPE_FERMENTATION,
    ...(opts.beer_recipe_id != null
      ? { beer_recipe_id: opts.beer_recipe_id }
      : { fermentation_settings: opts.fermentation_settings }),
  });

// Pagehide-only variant of startFermentationSession: same POST, but sent
// keepalive so it survives the tab closing mid-swap. Fire-and-forget.
export const startFermentationKeepalive = (deviceUUID, body) =>
  postKeepalive(api.sessions, {
    keg_uuid: deviceUUID,
    session_type: SESSION_TYPES.SESSION_TYPE_FERMENTATION,
    ...body,
  });
